import moment from 'moment';
export const dateToISO8601Format = date => {
  if (date) {
    return moment(new Date(date)).toISOString();
  } else {
    return '';
  }
};
